module.exports = __webpack_public_path__ + "img/fwlogo.e2827cad.png";